import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantAddCoapplicantPage = {
  alert: {
    error: 'applicant-add-coapplicant-page.alert.error',
  },
  footer: {
    root: 'applicant-add-coapplicant-page.footer.root',
  },
  form: {
    coapplicantDisclosure:
      'applicant-add-coapplicant-page.form.coapplicant-disclosure',
    h1: 'applicant-add-coapplicant-page.form.h1',
    h2: 'applicant-add-coapplicant-page.form.h2',
    radioGroupRoot: 'applicant-add-coapplicant-page.form.radio-group-root',
    radioOption1: 'applicant-add-coapplicant-page.form.radio-option-1',
    radioOption2: 'applicant-add-coapplicant-page.form.radio-option-2',
    root: 'applicant-add-coapplicant-page.form.root',
    submitButton: 'applicant-add-coapplicant-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
